module.exports = __webpack_public_path__ + "static/media/LI6.7aaf3547.jpg";